import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import page from 'v2/analytics/page';
import { useGetUser } from 'v2/core/services/user';
import { removeDynamicURLParts } from '../utils';

export const usePageViews = () => {
  const location = useLocation();
  const {
    tenant: { slug },
  } = useGetUser();

  useEffect(() => {
    if (!!slug) {
      // Fix for https://linear.app/enterpret/issue/ENG-5553/[bug]-page-view-are-not-getting-captured
      page(removeDynamicURLParts(slug), { location: location.pathname });
    }
  }, [location.pathname, slug]);
};
